import { useMutation } from '@tanstack/react-query';

import { organizationServices } from '@hero/services';

export const useCheckEmails = options => {
  return useMutation(body => organizationServices.checkEmails(body), {
    ...options
  });
};
